import { useMutation } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'

export enum EPayoutType {
  BANK = 'BANK',
  EWALLET = 'EWALLET',
}

export const DEFAULT_EWALLET = 'GOPAY'

export type TAddBankAccountPayload = {
  type: EPayoutType
  provider: string
  accountNumber: string
  accountName: string
}

export type TAddBankAccountResult = {
  success: boolean
  traceId: string
  error?: {
    code: string
    message: string
    errors: any[]
  }
  metadata: unknown
  result: unknown
}

async function postAddBankAccountAPI(
  { type, provider, accountNumber, accountName }: TAddBankAccountPayload,
  useMockServer: boolean = false,
): Promise<TAddBankAccountResult> {
  try {
    const result = await axiosInstance({
      baseURL: useMockServer
        ? process.env.NEXT_PUBLIC_MOCK_API_URL
        : process.env.NEXT_PUBLIC_API_URL,
      url: `/user/payout`,
      method: 'post',
      data: {
        type,
        provider,
        accountNumber: String(accountNumber),
        accountName,
      },
    })

    return result?.data
  } catch (error: any) {
    throw error?.response?.data
  }
}

export default function usePostAddBankAccountMutation() {
  const { mutate, isPending, isSuccess, data, error } = useMutation({
    mutationFn: ({ type, provider, accountNumber, accountName }: TAddBankAccountPayload) =>
      postAddBankAccountAPI({
        type,
        provider,
        accountNumber,
        accountName,
      }),
    onError: (err: any) => {
      const { error } = err
      return error
    },
  })

  return {
    mutate,
    data,
    isPending,
    isSuccess,
    error,
  }
}
